import { SiteFiltersStore } from "../store";

export function updateStageIds(stageIds: string[], store: SiteFiltersStore) {
  store.stageIds = stageIds;
}
